import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#65C3FF' cx='12' cy='12' r='12' />,
    <path
      key='1'
      fill='#FFFFFF'
      d='M12,5.2c-3.2,0-5.7,0.4-5.7,2.9v7.1c0,0.6,0.3,1.2,0.7,1.6v0.9c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1
	v-0.4h5.7v0.4c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-0.9c0.4-0.4,0.7-1,0.7-1.6V8.1C17.7,5.6,15.2,5.2,12,5.2z M8.8,15.9
	c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1C9.9,15.4,9.4,15.9,8.8,15.9z M15.2,15.9c-0.6,0-1.1-0.5-1.1-1.1
	c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1C16.3,15.4,15.8,15.9,15.2,15.9z M16.3,11.6H7.7V8.1h8.6V11.6z'
    />,
  ],
  'TransportConditionGeofenceBase'
);

const TransportConditionGeofenceBaseIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionGeofenceBaseIcon);
